import React from 'react';
import classnames from 'classnames';
import Scrollspy from 'react-scrollspy';

import * as styles from './asideNav.module.scss';

const AsideNav = ({ data }) => {
  return (
    <aside>
      <Scrollspy
        items={data.map(({ link }) => link)}
        currentClassName={classnames(styles.active)}
        className={classnames(styles.list)}
      >
        {data.map(({ link, lable }) => (
          <li key={link}>
            <a href={`#${link}`} id={`link-aside-nav-${link}`}>
              {lable}
            </a>
          </li>
        ))}
      </Scrollspy>
    </aside>
  );
};

export default AsideNav;
